import React from "react";
import PropTypes from "prop-types";

const Tooltip = ({ className, color }) => {
  switch (color) {
    case `gold`:
      color = `#B08F57`;
      break;

    case `orange`:
      color = `#EC5B2D`;
      break;

    default:
      break;
  }

  return (
    <svg className={className} viewBox="0 0 11 12" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.00024C0 9.03781 2.46243 11.5002 5.5 11.5002C8.53757 11.5002 11 9.03781 11 6.00024C11 2.96268 8.53757 0.500244 5.5 0.500244C2.46243 0.500244 0 2.96268 0 6.00024ZM10 6.00024C10 8.48553 7.98528 10.5002 5.5 10.5002C3.01472 10.5002 1 8.48553 1 6.00024C1 3.51496 3.01472 1.50024 5.5 1.50024C7.98528 1.50024 10 3.51496 10 6.00024ZM5.50016 8.49941C5.7764 8.49941 6.00033 8.27556 6.00033 7.99941C6.00033 7.72327 5.7764 7.49941 5.50016 7.49941C5.22393 7.49941 5 7.72327 5 7.99941C5 8.27556 5.22393 8.49941 5.50016 8.49941ZM5 7.00024H6C6 6.60107 6.06271 6.52791 6.47361 6.32246C7.18771 5.96541 7.5 5.60107 7.5 4.75024C7.5 3.66056 6.64217 3.00024 5.5 3.00024C4.39543 3.00024 3.5 3.89567 3.5 5.00024H4.5C4.5 4.44796 4.94772 4.00024 5.5 4.00024C6.13858 4.00024 6.5 4.27845 6.5 4.75024C6.5 5.14942 6.43729 5.22258 6.02639 5.42803C5.31229 5.78508 5 6.14942 5 7.00024Z"
        fill={color}
      />
    </svg>
  );
};

Tooltip.defaultProps = {
  className: ``,
  color: ``
};

Tooltip.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

export default Tooltip;
